import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ServicesContext } from 'app/items/shared/context_interface';
import { useIsCurrentRoute } from 'app/agriculture/hooks/useIsCurrentRoute';
import { Destructor } from 'app/shared/utilities/Destructor';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { Selection } from 'app/shared/selection/Selection';
import { SelectionType } from 'app/shared/selection/SelectionType';
import { useGetEntityType } from 'app/agriculture/models/useGetEntityType';
import { isEntityType } from 'app/agriculture/models/Entities';

/**
 * This ties the existing map selection service with react router
 *
 * I am not proud of this
 *
 * TODO: delete this once the selection service is no longer a thing
 */
export function useSelectionServiceRouterConnectionEffect() {
    const { selectionService } = useContext(ServicesContext);
    const { goto } = useRouteActions();
    const navigate = useNavigate();
    const params = useParams();
    const isCurrentRoute = useIsCurrentRoute();
    const getEntityType = useGetEntityType();

    // Listen for route change, select a thing when it does
    useEffect(() => {
        if (params.id == null) return;
        const numberId = Number(params.id);
        const id = isNaN(numberId) ? params.id : numberId;

        if (typeof id === 'string') {
            // TODO: SelectionSubType ??
            selectionService.setSelection(new Selection(id, SelectionType.ENTITY));
        } else {
            selectionService.setSelection(new Selection(id, SelectionType.ASSET));
        }
    }, [params.id, selectionService]);

    // Listen for selection change, change route when it does
    useEffect(() => {
        const destructor = new Destructor();
        destructor.add(
            selectionService.onSelectionChange(({ selected, deselected }) => {
                // if nothing is selected check if there was something deselected
                // if something was deselected, and we're currently on that route, navigate away
                // otherwise we are probably on another route anyway
                if (selected.length === 0) {
                    const [{ id = null } = {}] = deselected;
                    if (deselected.length > 0 && id != null && isCurrentRoute(id))
                        navigate(`/${params.farmId}`);
                    return;
                }

                const [{ id = null } = {}] = selected;
                if (id == null) return;
                const type = getEntityType(id);
                // navigate to the new selection, but not if we're already there
                if (isCurrentRoute(id) || !isEntityType(type)) return;
                goto(id, { type });
            }),
        );

        return destructor.destroy;
    }, [getEntityType, navigate, selectionService, isCurrentRoute, goto]);
}
